const indexItems = [
  { icon: 'ri-star-line', label: '探花精选', desc: '编辑严选优质内容', accent: 'bg-accent-100 text-accent-700' },
  { icon: 'ri-fire-line', label: '探花热门', desc: '实时人气飙升作品', accent: 'bg-primary-100 text-primary-700' },
  { icon: 'ri-user-star-line', label: '探花大神', desc: '知名创作者合集', accent: 'bg-secondary-100 text-secondary-700' },
  { icon: 'ri-layout-grid-line', label: '探花一区', desc: '分类专区内容索引', accent: 'bg-accent-100 text-accent-700' },
  { icon: 'ri-movie-line', label: '探花91', desc: '精品社区内容板块', accent: 'bg-primary-100 text-primary-700' },
  { icon: 'ri-award-line', label: '极品探花', desc: '高分口碑资源汇总', accent: 'bg-secondary-100 text-secondary-700' },
  { icon: 'ri-stack-line', label: '探花合集', desc: '系列作品完整收录', accent: 'bg-accent-100 text-accent-700' },
  { icon: 'ri-flashlight-line', label: '探花新品', desc: '最新上架内容首发', accent: 'bg-primary-100 text-primary-700' },
  { icon: 'ri-heart-line', label: '探花推荐', desc: '社区口碑佳作推荐', accent: 'bg-secondary-100 text-secondary-700' },
];

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-14 md:py-18 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-4">
            <i className="ri-compass-3-line"></i>
            内容导航
          </div>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
            主题索引
          </h2>
          <p className="mt-2 text-sm text-foreground-500 max-w-lg mx-auto">
            快速定位你感兴趣的探花内容板块，一站直达目标专区
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-4">
          {indexItems.map((item, i) => (
            <a
              key={i}
              href={`#${i < 3 ? 'cards' : 'topics'}`}
              onClick={(e) => { e.preventDefault(); document.querySelector(`#${i < 3 ? 'cards' : 'topics'}`)?.scrollIntoView({ behavior: 'smooth' }); }}
              className="flex items-start gap-3 p-4 md:p-5 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/30 transition-all duration-200 cursor-pointer group"
            >
              <div className={`w-10 h-10 rounded-lg flex items-center justify-center shrink-0 ${item.accent}`}>
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <div className="min-w-0">
                <h3 className="text-sm font-semibold text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                  {item.label}
                </h3>
                <p className="text-xs text-foreground-500 mt-0.5">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}